class UrlEndpoints {
    static LOGIN_USER = 'LOGIN_USER';
    static GET_AUTHENTICATION_TOKEN = 'GET_AUTHENTICATION_TOKEN';
    static SAVE_USER_DATA = 'SAVE_USER_DATA';
    static RESET_PASSWORD = 'RESET_PASSWORD';
    static GET_ISSUES = 'GET_ISSUES';
    static DELETE_ISSUE = 'DELETE_ISSUE';
    static GET_USERS = 'GET_USERS';
    static POST_USER_DATA = 'POST_USER_DATA';
    static GET_ROLES = 'GET_ROLES';
    static DELETE_ROLE = 'DELETE_ROLE';
    static GET_USER = 'GET_USER';
    static PATCH_USER_DATA = 'PATCH_USER_DATA';
    static DEACTIVATE_USER = 'DEACTIVATE_USER';
    static POST_ROLE = 'POST_ROLE';
    static GET_ROLE = 'GET_ROLE';
    static PATCH_ROLE = 'PATCH_ROLE';
    static GET_ISSUE = 'GET_ISSUE';
    static PATCH_ISSUE = 'PATCH_ISSUE';
    static ACTIVATE_USER = 'ACTIVATE_USER';

    static getUrlEndpoint(url, params) {
        //const ROOT_URL = 'http://localhost:9876/api/';
        const ROOT_URL = 'https://private-463b4b-garrett9.apiary-mock.com/';
        const LOGIN_URL = ROOT_URL + 'login';
        const GET_AUTHENTICATION_TOKEN_URL = ROOT_URL + 'auth/token';
        const RESET_PASSWORD_URL = ROOT_URL + 'reset-password';
        const ISSUES_URL = ROOT_URL + 'issues';
        const ISSUE_URL = ROOT_URL + 'issues/' + params;
        const USER_URL = ROOT_URL + 'users/' + params;
        const USER_DEACTIVATION_URL = ROOT_URL + 'users/' + params + '/deactivate';
        const USER_ACTIVATION_URL = ROOT_URL + 'users/' + params + '/activate';
        const USER_DATA_URL = ROOT_URL + 'users';
        const ROLES_URL = ROOT_URL + 'roles';
        const ROLE_URL = ROOT_URL + 'roles/' + params;

        switch (url) {
            case 'LOGIN_USER':
                return LOGIN_URL;
            case 'GET_AUTHENTICATION_TOKEN':
                return GET_AUTHENTICATION_TOKEN_URL;
            case 'SAVE_USER_DATA':
                return USER_DATA_URL;
            case 'RESET_PASSWORD':
                return RESET_PASSWORD_URL;
            case 'GET_ISSUES':
                return ISSUES_URL;
            case 'DELETE_ISSUE':
                return ISSUE_URL;
            case 'GET_USER':
                return USER_URL;
            case 'PATCH_USER_DATA':
                return USER_URL;
            case 'GET_USERS':
                return USER_DATA_URL;
            case 'POST_USER_DATA':
                return USER_DATA_URL;
            case 'GET_ROLES':
                return ROLES_URL;
            case 'DEACTIVATE_USER':
                return USER_DEACTIVATION_URL;
            case 'ACTIVATE_USER':
                return USER_ACTIVATION_URL;
            case 'DELETE_ROLE':
                return ROLE_URL;
            case 'POST_ROLE':
                return ROLES_URL;
            case 'GET_ROLE':
                return ROLE_URL;
            case 'PATCH_ROLE':
                return ROLE_URL;
            case 'GET_ISSUE':
                return ISSUE_URL;
            case 'PATCH_ISSUE':
                return ISSUE_URL;
            default:
                return null;
        }
    }
}

export default UrlEndpoints;
